export default "dist/images/components-columns-width-control-3-1-uneven.d1838a7.png";